/* eslint-disable no-undef,no-restricted-syntax,no-prototype-builtins */
import CONSTANTS, { CACHE, RESPONSE_STATUS } from './constants';
import { getKey, isMobileDevice } from './common';
import { getStaticPath, isWebViewFlow } from '../../../common/src/utils/common';
import { EVENT, log } from '../common/logger';

let popupLoaded = false;

const _submitForm = (res, cache) => {
  const w = cache.getData(CONSTANTS.POPUP_WINDOW);
  if (w) {
    if (res && res.body && res.body.resultInfo && res.body.resultInfo.resultStatus === 'S') {
      w.postMessage(res.body, '*');
    } else {
      // pay api failed and set the IS_SELF_CLOSE to true
      cache.setData(CONSTANTS.IS_SELF_CLOSE, true);
      /* if retry is set true dont hide overlay  to show the retry msg */
      const retryValue = getKey(res, 'body.resultInfo.retry', false);
      if (!retryValue) {
        cache.getData(CACHE.STORE).setState({ overlayValue: '' });
      }
      w.close();
      popupLoaded = false;
    }
  }
};

const bankPopupMessageHandler = (cache, e) => {
  if (e.data.type === 'BANK_HTML_LOADED') {
    popupLoaded = true;
    if (cache.getData(CACHE.DEFERRED_POPUP_DATA)) {
      const { res } = cache.getData(CACHE.DEFERRED_POPUP_DATA);
      _submitForm(res, cache);
    }
  }
};

const shouldWindowOpen = selected => {
  if (
    selected &&
    (selected.type === 'nb' ||
      selected.type === 'sc' ||
      selected.type === 'card' ||
      selected.type === 'upi' ||
      selected.type === 'ppbl' ||
      selected.type === 'emi' ||
      selected.type === 'upipush' ||
      selected.type === CONSTANTS.BM ||
      selected.type === CONSTANTS.SAVED_BANK_MANDATE_PAY_TYPE)
  ) {
    return true; // open window popup if paymode is nb,saved card , card ( credit , debit ) , upi collect , payment bank ( ppb ) , postpaid ( pdc )
  }
  return false;
};

const notifyPaymentStatusFromPopup = (popup, cache) => {
  function notifyFromPopup(event) {
    if (event.source === popup) {
      if (event.data.type === 'BANK_HTML_LOADED') {
        bankPopupMessageHandler(cache, event);
      } else {
        popup.close();
        window.removeEventListener('message', notifyFromPopup, false);
      }
    }
  }
  return notifyFromPopup;
};

export const _getFormHtmlNode = data => {
  const node = document.createElement('form');
  node.action = data.callbackUrl || data.callBackUrl || '';
  node.method = 'post';
  for (const key in data.content) {
    if (data.content.hasOwnProperty(key)) {
      const inputNode = document.createElement('input');
      const value = data.content[key];
      inputNode.type = 'hidden';
      inputNode.value = value;
      inputNode.name = key;
      node.appendChild(inputNode);
    }
  }
  return node;
};

const _handleTxnStatusData = (cache, data) => {
  const config = cache.getData(CACHE.MERCHANT_CONFIG);
  cache.getData(CACHE.STORE).setState({ overlayValue: '' });
  log({ eventType: EVENT.TXN_STATUS_HANDLED });
  /* setting popup data to be null so that every time there is a new txn, new data is picked */
  cache.setData(CACHE.DEFERRED_POPUP_DATA, null);

  if (getKey(data, 'body.resultStatus') === RESPONSE_STATUS.F && getKey(data, 'body.retry')) {
    cache.getData(CACHE.STORE).setState({
      overlayValue: CONSTANTS.RETRY,
      retryMessage: getKey(data, 'body.resultMsg'),
      isPollingRequired: false
    });
  } else if (getKey(config, 'merchant.redirect')) {
    const form = _getFormHtmlNode(data.body);
    document.body.appendChild(form);
    form.submit();
  } else {
    const merchantHandler = config.handler && config.handler.transactionStatus;
    if (typeof merchantHandler === 'function') {
      merchantHandler(data.body.content);
    }
  }
};

export const paymentConfirmation = (cache, retryCallback) => {
  const config = cache.getData(CACHE.MERCHANT_CONFIG);
  const isPaymentConfirmationRequestInProgress = cache.getData(
    CONSTANTS.IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS
  );
  if (isPaymentConfirmationRequestInProgress === true) {
    return;
  }
  cache.setData(CONSTANTS.IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS, true);
  cache
    .getData(CACHE.API)
    .status(getKey(config, 'merchant.mid', undefined), getKey(config, 'data.orderId', undefined))
    .then(res => {
      cache.setData(CONSTANTS.IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS, false);
      _handleTxnStatusData(
        cache,
        {
          body: {
            callbackUrl: getKey(res, 'body.callbackUrl', undefined),
            content: getKey(res, 'body.txnInfo', undefined),
            resultMsg: getKey(res, 'body.resultInfo.resultMsg', undefined),
            resultStatus: getKey(res, 'body.resultInfo.resultStatus', undefined),
            retry: getKey(res, 'body.resultInfo.retry', false)
          }
        },
        config
      );
    })
    .catch(err => {
      cache.setData(CONSTANTS.IS_PAYMENT_REQUEST_CONFIRMATION_PROGRESS, false);
      cache.getData(CACHE.STORE).setState({ overlayValue: '' });
      const resultInfo = getKey(err, 'body.resultInfo', undefined);
      if (retryCallback) {
        retryCallback(resultInfo || {});
      }
    });
};

const _onCloseWatcher = (win, retryCallback, cache) => {
  const timer = setInterval(() => {
    if (win.closed) {
      clearInterval(timer);
      popupLoaded = false;
      if (
        cache.getData(CONSTANTS.IS_SELF_CLOSE) !== true &&
        !cache.getData(CONSTANTS.IS_DIRECT_BANK, false)
      ) {
        paymentConfirmation(cache, retryCallback);
      }
    }
  }, 1000);
  window.addEventListener('message', notifyPaymentStatusFromPopup(win, cache), false);
};

const _getOptimalDimension = (evaluated, minBestFit, maxBestFit) => {
  return Math.min(Math.max(Math.floor(evaluated), minBestFit), maxBestFit);
};

const _openCenteredWindowPopup = (url, name) => {
  if (isMobileDevice()) {
    return window.open(url, name);
  }

  const width = _getOptimalDimension(0.7 * window.innerWidth, 895, 1440);
  const height = _getOptimalDimension(0.8 * window.innerHeight, 520, 1060);
  const top = parseInt(
    window.outerHeight / 2 - (height - (window.screenY || window.screenTop)) / 2,
    10
  );
  const left = parseInt(
    window.outerWidth / 2 - (width - (window.screenX || window.screenLeft)) / 2,
    10
  );

  return window.open(
    url,
    name,
    `toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=${width}, height=${height}, top=${top}, left=${left}`
  );
};

export const openPopUpWindow = cache => {
  /* setting popup data to be null so that every time there is a new txn, new data is picked */
  cache.setData(CACHE.DEFERRED_POPUP_DATA, null);
  const selected = getKey(cache.getData(CACHE.STORE).getState(), 'selected', {});
  const isBankPageBlocked = cache.getData(CONSTANTS.IS_BANKPAGE_REQUIRED_BLOCKED, false);
  const mConfig = cache.getData(CACHE.MERCHANT_CONFIG);
  const webViewFlow = isWebViewFlow(mConfig);
  cache.setData(CONSTANTS.WEB_VIEW_FLOW, webViewFlow);
  if (!webViewFlow && !isBankPageBlocked && shouldWindowOpen(selected)) {
    const w = _openCenteredWindowPopup(`${getStaticPath()}/assets/iframes/bank.html`, '_blank');
    if (w) {
      try {
        w.addEventListener('message', bankPopupMessageHandler.bind(this, cache), false);
      } catch (e) {}
      cache.setData(CONSTANTS.POPUP_WINDOW, w);
      cache.setData(CONSTANTS.IS_SELF_CLOSE, false);
      _onCloseWatcher(w, () => {}, cache);
    }
  }
};

export const handlePostData = (data, cache) => {
  _handleTxnStatusData(cache, data);
};

/* setting force close because in case of deferred flow api is returniing error before the bank page can be loaded */
export const postInWindow = (res, cache, forceClose) => {
  if (popupLoaded) {
    _submitForm(res, cache);
  } else if (cache.getData(CONSTANTS.WEB_VIEW_FLOW)) {
    const form = _getFormHtmlNode(res.body);
    document.body.appendChild(form);
    form.submit();
  } else if (res && Object.keys(res).length) {
    cache.setData(CACHE.DEFERRED_POPUP_DATA, { res, forceClose });
  } else if (forceClose === true) {
    _submitForm(res, cache);
  }
};

export const openWindowPopup = cache => {
  const selected = getKey(cache.getData(CACHE.STORE).getState(), 'selected', {});
  shouldWindowOpen(selected) && openPopUpWindow(cache);
};



// WEBPACK FOOTER //
// ./utils/formPost.js